import React, { memo, useCallback } from 'react';
import { View, Text, Pressable, Image } from 'react-native';
import { COLOR, FONT } from '../../constants/styles';
import { I18n, Navigation } from '../components';

import { useDispatch, useSelector } from 'react-redux';

import Patients from '../cases/medRecruiter/lookup';
import Scheduling from '../staffScheduling/main';
import Staff from '../staff/main';

import { getComposedCurrentEmployerPermissions } from '../../selectors/permissions';

import { STAFF_SCHEDULING } from '../../constants/permissions';

import GreetingHeader from '../employer/greeting_header';

const ROUTES = {
  Patients,
  Scheduling,
  Staff,
};

export default memo(function MedRecruiterHome(props) {
  const Comp = ROUTES[props.screen];

  const canEditStaffSchedule = useSelector(getComposedCurrentEmployerPermissions)?.[
    STAFF_SCHEDULING
  ]?.canEdit;

  const handleExportPress = useCallback(() => {
    Navigation.showModal({
      screen: 'StaffScheduleExportForm',
      title: I18n.ac('export'),
    });
  }, []);

  const exportButton =
    canEditStaffSchedule && props.screen === 'Scheduling' ? (
      <Pressable
        style={[
          {
            paddingVertical: 15,
            paddingHorizontal: 10,
            height: 55,
            width: 150,
            backgroundColor: COLOR.emphasis,
            borderRadius: 5,
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          },
        ]}
        onPress={handleExportPress}
      >
        <Image
          source={require('../../../resources/icon-logout.png')}
          style={{
            width: 10,
            height: 12,
            tintColor: 'white',
            marginRight: 10,
          }}
        />
        <Text
          style={{
            ...FONT.regular,
            fontSize: 14,
            color: 'white',
            textAlign: 'center',
          }}
        >
          EXPORT
        </Text>
      </Pressable>
    ) : null;

  return (
    <View style={{ flex: 1 }}>
      <GreetingHeader>{exportButton}</GreetingHeader>
      <View style={{ flex: 1 }}>{Comp && <Comp {...props} />}</View>
    </View>
  );
});
